import React from 'react'
import {browserHistory} from 'react-router'
import Datagrid from '../../Component/Table'

class Search extends React.Component {

  constructor (props) {
    super(props)
  }

  static update (row) {
    browserHistory.push({
      pathname: '/crm/' + row.id
    })
  }

  render () {
    return (<Datagrid onClick={Search.update} search={'client_filtre_main'} type={'client'}/>)
  }
}

export default Search





// WEBPACK FOOTER //
// ./app/App/Module/CRM/Page/Filtre/index.js